import React from "react";
import icon1 from "@imgs/home/top_icon_left.png";
import icon2 from "@imgs/home/top_icon_right.png";
import styles from "./index.module.scss";

export const Banner = () => {
  return <div className={styles.banner}>
    <div className={styles.left}>
      <img src={icon1}  alt={''}/>
      <div className={styles.text}>基于国产自主高性能区块链ChainMaker研发的可信存证平台，为电子证据的生成、存储、传递保驾护航</div>
    </div>
    <div className={styles.right}>
      <img className={styles.img} src={icon2}  alt={''}/>
    </div>
  </div>
}
